export interface IElementRef {
    myopId?: string
    htmlTagName: string
    BoundingRect?: DOMRect
    offsetTop?: number
    offsetLeft?: number

    type: string
}

export class XPathElementRef implements IElementRef {
    constructor(public xPath: string,
                public htmlTagName: string,
                public BoundingRect?: DOMRect,
                public offsetTop?: number,
                public offsetLeft?: number) {
    }

    public readonly type: string = 'XPathElementRef'
}

export class MyopElementRef implements IElementRef {
    constructor(public myopId: string,
                public htmlTagName: string,
                public BoundingRect?: DOMRect,
                public offsetTop?: number,
                public offsetLeft?: number) {

    }

    public readonly type: string = 'MyopElementRef'
}
